// Full-width photographic break between text-heavy sections.
// `framed` shows the whole photograph uncropped in a bordered frame,
// for shots where the full scene (e.g. the complete instrument kit) matters.
export default function PhotoBand({ src, alt, caption, framed = false }) {
  if (framed) {
    return (
      <section className="border-y border-hairline py-12 sm:py-16" data-testid="photo-band">
        <figure className="site-x mx-auto max-w-4xl">
          <div className="photo-frame border border-hairline bg-raised p-2.5">
            <img
              src={src}
              alt={alt}
              loading="lazy"
              className="h-auto w-full"
              data-testid="photo-band-image"
            />
          </div>
          {caption && (
            <figcaption className="mt-3 text-sm uppercase tracking-[0.16em] text-sub">
              {caption}
            </figcaption>
          )}
        </figure>
      </section>
    );
  }
  return (
    <section className="border-y border-hairline" data-testid="photo-band">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="max-h-[70vh] w-full object-cover"
        data-testid="photo-band-image"
      />
      {caption && (
        <p className="site-x py-3 text-sm uppercase tracking-[0.16em] text-sub">
          {caption}
        </p>
      )}
    </section>
  );
}
